module.exports = __webpack_public_path__ + "img/fritz-pantry-landscape-768w.73d0c783.jpg";